module.exports = __webpack_public_path__ + "static/media/new_chat.bfaca85e.mp3";